import gql from "graphql-tag"
import { MembershipFragmentDoc } from "../../api/generated"

export default gql`
  {
    me {
      id
      membership {
        ...Membership
      }
    }
  }
  ${MembershipFragmentDoc}
`
